import { privateApi } from 'services';
import { ContentLibraryMessage } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const createMessage = async (payload: { text: string }, businessAccountId: string): Promise<ContentLibraryMessage> =>
    privateApi.post<ContentLibraryMessage>(
        `business-accounts/${businessAccountId}/content-library/message-items`,
        payload,
    );

const updateMessageStatus = async (messageId: string, isArchived: boolean): Promise<ContentLibraryMessage> =>
    privateApi.put<ContentLibraryMessage>(`content-library/message-items/${messageId}`, {
        archived: isArchived,
    });

export const ContentLibraryMessageGateway = {
    createMessage,
    updateMessageStatus,
};

const cancelableFetchMessages = async (businessAccountId: string): Promise<ContentLibraryMessage[]> =>
    privateApiWithRouteLeavingCancelation.get<ContentLibraryMessage[]>(
        `business-accounts/${businessAccountId}/content-library/message-items`,
    );

export const CancelableContentLibraryMessageGateway = {
    cancelableFetchMessages,
};
